export const BET_BUILDER = 'BetBuilder';

export const TicketTypes = {
  DEPOSIT: 'deposit',
  SPORT: 'sport',
  CASINO: 'casino',
  ADMIN: 'admin',
  BET_BUILDER: 'bet_builder',
};

export const TerminalTicketTypeEnum = {
  [TicketTypes.SPORT]: 1,
  [TicketTypes.CASINO]: 2,
}